var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSmoking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: props.color
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.949 21h2v-8h-2zM24.949 21h2v-8h-2zM22.59 6.003c2.954 0 5.358 2.234 5.358 4.979h2c0-3.848-3.3-6.978-7.359-6.978-1.209 0-2.193-.898-2.193-2.002h-2c0 2.207 1.88 4.002 4.193 4.002"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.755 6.98C19.8 6.98 17.396 4.745 17.396 2h-2c0 3.848 3.301 6.978 7.36 6.978 1.208 0 2.192.898 2.192 2.002h2c0-2.207-1.88-4.002-4.193-4.002M11.772 15h11.177v-2H3.052a1 1 0 00-1 1v6a1 1 0 001 1h19.897v-2H4.052v-4h7.72z"
  })))));
}

export default SvgIconSmoking;